module.exports = __webpack_public_path__ + "img/45327dc.jpg";